import React from "react";
import TopLine from "../common/TopLine";
import TitleCell from "../common/List/TitleCell";
import uniqid from "uniqid";
import { useQuery } from "@tanstack/react-query";
import { fetchWithToken } from "../../functions/fetch";
import Row from "../common/List/Row";

const OverviewPage = () => {
  const titles = ["房型", "總間數", "已出租", "已預定", "未出租"];

  const fetchOverview = async () => {
    const res = await fetchWithToken(
      "GET",
      `${process.env.REACT_APP_BACKEND_HOST}/api/room/overview`,
    );
    return res.result;
  };
  const { data, isFetched } = useQuery({
    queryKey: ["roomOverview"],
    queryFn: fetchOverview,
    initialData: null,
  });
  return (
    <div>
      <TopLine />
      {/* basically list component with different width (w-fit) */}
      <div className="grid border-2 mt-8 w-fit mx-12 bg-light-border-gray gap-x-0.5 gap-y-0.5 auto-rows-min grid-cols-[repeat(5,minmax(100px,1fr))]">
        {titles.map((title) => (
          <TitleCell key={uniqid()} text={title} />
        ))}
        {isFetched ? (
          data.map((item) => {
            const { roomType, totalCount, rented, reserved, notRented } = item;
            const cellTexts = [
              roomType,
              totalCount,
              rented,
              reserved,
              notRented,
            ];
            return (
              <Row
                key={uniqid()}
                cellTexts={cellTexts}
                noteTexts={[]}
                showPopUp={() => {}}
              />
            );
          })
        ) : (
          <div>載入中</div>
        )}
      </div>
    </div>
  );
};

export default OverviewPage;
